import { REGEX } from "../constants/regex";
import { Commande } from "../1_types/genericTypes";
import { isStringNotNull } from "./";
export const isRoulettePromoCode = (promoCode: string): boolean => {
  const regex = new RegExp(REGEX.ROULETTE_PROMO_CODE);

  return regex.test(promoCode);
};

export const getAllowPromoCodes = (
  shopConfiguration: any,
  marketing: any,
  commande: Commande,
): boolean => {
  const hasMarketingCampaign = Object.values(commande ?? {}).some((item) =>
    isStringNotNull(item.productMarketingCampaignKey),
  );
  if (!hasMarketingCampaign) {
    return true;
  }

  const companyAllowPromoCodes = marketing?.allowPromoCodes;
  const shopAllowPromoCodes = shopConfiguration?.marketing?.allowPromoCodes;

  return companyAllowPromoCodes === false
    ? false
    : (shopAllowPromoCodes ?? companyAllowPromoCodes ?? true);
};
